import { useState } from "react";
import { Link } from "react-router-dom";
import { FEATURED, CATEGORIES } from "../content/marketplace-content-loader";
import { SIGNUP_FORM_URL } from "../external-links";

/* ────── Utility Icons ────── */

function SearchIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="9" r="6" />
      <path d="M15 15l-3-3" />
    </svg>
  );
}

function StarIcon() {
  return (
    <svg viewBox="0 0 12 12" fill="#C4993C" stroke="none">
      <path d="M6 .8l1.5 3 3.3.5-2.4 2.3.6 3.4L6 8.2 3 10l.6-3.4L1.2 4.3l3.3-.5z" />
    </svg>
  );
}

function DownloadIcon() {
  return (
    <svg viewBox="0 0 12 12" fill="none" stroke="#A89CA4" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 2v6M3.5 5.5L6 8l2.5-2.5" />
      <path d="M2.5 10h7" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 8h10M9 4l4 4-4 4" />
    </svg>
  );
}

/* ────── Page Component ────── */

export function MarketplacePage() {
  const [search, setSearch] = useState("");

  return (
    <>
      {/* ===== HERO ===== */}
      <section className="mkt-hero">
        <h1 className="mkt-hero-title">
          Discover <span className="mkt-hero-accent">Guides</span>.
        </h1>
        <p className="mkt-hero-subtitle">
          Install expert health AI guides directly into your vault. Built by
          researchers, doctors, and biohackers.
        </p>
        <div className="mkt-search-row">
          <div className="mkt-search-input">
            <SearchIcon />
            <input
              type="text"
              placeholder="Search guides or biomarkers..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>
      </section>

      {/* ===== FEATURED PROTOCOLS ===== */}
      <section className="mkt-featured-section">
        <div className="section-header">
          <h2 className="section-heading">Featured Guides</h2>
        </div>
        <div className="mkt-featured-grid">
          {FEATURED.map((p) => (
            <Link
              key={p.name}
              to={`/marketplace/${p.slug}`}
              className="mkt-featured-card"
            >
              <div className="mkt-featured-badges">
                <span className="mkt-featured-badge">
                  <StarIcon /> {p.rating}
                </span>
                <span className="mkt-featured-badge">
                  <DownloadIcon /> {p.installs}
                </span>
              </div>
              <div
                className="mkt-featured-icon"
                style={{ background: p.iconBg }}
              >
                {p.icon}
              </div>
              <h3 className="mkt-featured-name">{p.name}</h3>
              <p className="mkt-featured-desc">{p.desc}</p>
              <span
                className="mkt-install-btn"
                style={{ background: p.buttonBg }}
              >
                Install Guide
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* ===== BROWSE BY CATEGORY ===== */}
      <section className="mkt-categories-section">
        <div className="section-header">
          <h2 className="section-heading">Browse by Category</h2>
        </div>
        <div className="mkt-categories-grid">
          {CATEGORIES.map((c) => (
            <Link
              key={c.name}
              to={`/marketplace/category/${c.slug}`}
              className="mkt-category-card"
            >
              <div
                className="mkt-category-icon"
                style={{ background: c.color }}
              >
                {c.icon}
              </div>
              <div className="mkt-category-info">
                <span className="mkt-category-name">{c.name}</span>
                <span className="mkt-category-count">{c.count} guides</span>
              </div>
              <span className="mkt-category-arrow">
                <ArrowRightIcon />
              </span>
            </Link>
          ))}
        </div>
      </section>

      {/* ===== CREATOR CTA ===== */}
      <section className="mkt-creator-cta">
        <h2 className="mkt-creator-cta-heading">
          Share your expertise with the world.
        </h2>
        <p className="mkt-creator-cta-desc">
          Publish your guides and earn revenue. Join the health AI creator
          community.
        </p>
        <a href="#" className="hero-cta-outlined">
          Become a Kin Creator
        </a>
      </section>
    </>
  );
}
